import { GraphQlQueryResult, QuerySuccessResultCreator } from '../../graphql-result';
export class RecommendationSuccessResultCreator extends QuerySuccessResultCreator {
  constructor(response, data) {
    super(response, data);
    this.response = response;
  }
  makeQueryResult() {
    return new GraphQlQueryResult(this.response.status, this.response.statusText, {
      data: this.data
    });
  }
}